import * as Yup from "yup";

export const createSchema = (languages) => {
    const multiLangString = Yup.object(
        Object.fromEntries(
            languages.map((lng) => [
                lng,
                Yup.string().trim().required("Required"),
            ])
        )
    );

    const multiLangStringOptional = Yup.object(
        Object.fromEntries(languages.map((lng) => [lng, Yup.string()]))
    );

    const multiLangOptions = Yup.object(
        Object.fromEntries(
            languages.map((lng) => [lng, Yup.string().required("Required")])
        )
    );

    return Yup.object({
        name: Yup.string().required("Form name is required"),

        text: multiLangString, // multilingual text required

        type: Yup.string()
            .oneOf(["section-wise"], "Invalid type")
            .required("Type is required"),

        payload: Yup.object({
            sections: Yup.array()
                .of(
                    Yup.object({
                        key: Yup.string().required("Section key is required"),

                        name: multiLangString,
                        is_accordian: Yup.boolean(),

                        incremental: Yup.boolean(),

                        fields: Yup.array()
                            .of(
                                Yup.object({
                                    key: Yup.string().required(
                                        "Field key is required"
                                    ),

                                    name: multiLangString, // multilingual field name

                                    field_type: Yup.string()
                                        .required("Field type is required")
                                        .oneOf(
                                            [
                                                "input",
                                                "number-input",
                                                "date-input",
                                                "single-select",
                                                "single-select-other",
                                                "multi-select",
                                                "multi-select-other",
                                                "dropdown",
                                            ],
                                            "Invalid field type"
                                        ),

                                    options: multiLangOptions, // multilingual options array

                                    other_text: multiLangStringOptional, // validated conditionally (below)

                                    validation: Yup.boolean().required(),

                                    more: Yup.object().optional(),
                                }).test(
                                    "other-text-required",
                                    "other_text must exist for *-other field types",
                                    function (field) {
                                        const { field_type, other_text } =
                                            field;

                                        const requiresOther = [
                                            "single-select-other",
                                            "multi-select-other",
                                        ];

                                        if (
                                            requiresOther.includes(field_type)
                                        ) {
                                            // must exist AND have all languages
                                            return (
                                                other_text &&
                                                languages.every(
                                                    (lng) =>
                                                        other_text[lng] !==
                                                        undefined
                                                )
                                            );
                                        }

                                        // If NOT other type, allow empty or removed
                                        return true;
                                    }
                                )
                            )
                            .min(1, "At least one field is required"),
                    })
                )
                .min(1, "At least one section is required"),
        }),
    });
};
